import Sortable, { MultiDrag } from "sortablejs/modular/sortable.esm.js";

Sortable.mount(new MultiDrag());

export const vSortable = {
  mounted(el, binding) {
    el._sortableInstance = new Sortable(el, binding.value || {});
  },
  updated(el, binding) {
    if (!el._sortableInstance) return;
    const opts = binding.value || {};
    el._sortableInstance.option("disabled", opts.disabled ?? false);
  },
  unmounted(el) {
    if (el._sortableInstance) {
      el._sortableInstance.destroy();
      el._sortableInstance = null;
    }
  },
};
